import {EditRecipient} from "./edit-recipient";

export default EditRecipient;